import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
  Heading,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { browseTitleMap, urlMap } from "../../../core/constants";
import DCLogo from "../../../resources/images/dc_comics.svg";
import ImageLogo from "../../../resources/images/image.svg";
import MarvelLogo from "../../../resources/images/marvel.svg";
import StarWarsLogo from "../../../resources/images/star_wars.svg";
import { trackEvent } from "../../../shared/analytics";
import BrowseList from "../../browse/components/BrowseList";
import BrowseSectionTitle from "../../browse/components/BrowseSectionTitle";
import ReleaseSections from "../components/ReleaseSections";
import { RELEASE_FRANCHISES } from "../helpers/releases";

const CATEGORY = "cinematic-universes";
const LOGOS = {
  marvel: { src: MarvelLogo, height: 30 },
  dc: { src: DCLogo, height: 30 },
  starwars: { src: StarWarsLogo, height: 45 },
  image: { src: ImageLogo, height: 29 },
};

/**
 * Cinematic Universes: per franchise, the next and latest movies / shows
 * (with a "Reading order available" badge) above the matching reading orders.
 * Mirrors the mobile ScreenReleasesScreen.
 */
const CinematicUniverses = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Container maxW="container.lg">
      <Breadcrumb mt="6">
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/browse">
            Browse
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink as={Link} to="#">
            {browseTitleMap[CATEGORY]}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Heading as="h2" mb="6">
        {browseTitleMap[CATEGORY]}
      </Heading>
      <Tabs
        index={tabIndex}
        onChange={(index) => {
          trackEvent("browse_release_tab_click", {
            tab: RELEASE_FRANCHISES[index].key,
          });
          setTabIndex(index);
        }}
        isLazy
      >
        <TabList>
          {RELEASE_FRANCHISES.map((franchise) => (
            <Tab key={franchise.key} aria-label={franchise.label}>
              <Image
                src={LOGOS[franchise.key].src}
                height={LOGOS[franchise.key].height}
                alt=""
              />
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {RELEASE_FRANCHISES.map((franchise) => (
            <TabPanel key={franchise.key} px="0">
              {!!franchise.slug && (
                <ReleaseSections releaseFranchise={franchise} />
              )}
              <BrowseSectionTitle>
                Cinematic Universes reading orders
              </BrowseSectionTitle>
              <BrowseList
                type={urlMap[CATEGORY]}
                franchise={franchise.franchise}
              />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default CinematicUniverses;
